import { useState } from "react";
import { PencilSquareIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

export default function ProvinceAccordion({ province, onEdit }) {
  const [open, setOpen] = useState(false);

  const cities = province.cities || [];

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition p-4 border border-gray-100">
      <div className="flex justify-between items-center">
        <div
          className="flex items-center gap-2 cursor-pointer flex-1"
          onClick={() => setOpen(!open)}
        >
          <ChevronDownIcon
            className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
              open ? "rotate-180" : ""
            }`}
          />
          <div className="flex items-center gap-3">
            <h3 className="font-semibold text-gray-800">{province.name}</h3>
            <span
              className={`inline-block w-2 h-2 rounded-full ${
                province.is_active ? "bg-green-500" : "bg-red-500"
              }`}
              title={province.is_active ? "فعال" : "غیرفعال"}
            />
            <span className="text-xs text-gray-500">
              ({cities.length} شهر)
            </span>
          </div>
        </div>

        <button
          onClick={() => onEdit(province.id)}
          className="text-gray-400 hover:text-blue-600 transition p-1"
          title="ویرایش استان"
        >
          <PencilSquareIcon className="w-5 h-5" />
        </button>
      </div>

      {open && (
        <div className="mt-4 pr-7 space-y-2">
          {cities.length > 0 ? (
            cities.map((city) => (
              <div
                key={city.id}
                className={`flex justify-between items-center px-3 py-2 rounded-lg ${
                  city.is_active 
                    ? "bg-gray-50 hover:bg-gray-100" 
                    : "bg-gray-100 text-gray-400"
                } transition`}
              >
                <span className="text-sm">{city.name}</span>
                <div className="flex items-center gap-2">
                  <span
                    className={`inline-block w-2 h-2 rounded-full ${
                      city.is_active ? "bg-green-500" : "bg-red-300"
                    }`}
                  />
                  <span className="text-xs text-gray-500">
                    {city.is_active ? "فعال" : "غیرفعال"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-400 text-sm text-center py-2">
              هیچ شهری برای این استان ثبت نشده است
            </p>
          )}
        </div>
      )}
    </div>
  );
}